import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlMutation } from 'src/graphql/client';

const MUTATION = gql`
  mutation GetScoreForDocumentEditor(
    $text: String!
    $projectId: ID!
    $generationTool: GenerationToolEnum!
  ) {
    getScoreForDocumentEditor(text: $text, projectId: $projectId, generationTool: $generationTool) {
      id
      assetType
      text
      score
      lastUpdateTime
      ageScoreHistogram
      genderScoreHistogram
    }
  }
`;

export const getScoreForDocumentEditor = async ({ text, projectId, generationTool }) => {
  const variables = {
    text,
    projectId,
    generationTool,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
